module.exports = __webpack_public_path__ + "static/media/contato.32f3eb3d.jpg";